import styles from './ModeBar.module.css';

export type CategoryFilter = { id: string; label: string; isCustom?: boolean };

interface ModeBarProps {
  categories: CategoryFilter[];
  activeChips: string[];
  onToggleChip: (id: string) => void;
  onDeleteChip?: (id: string) => void;
  /** Collection-derived chip labels can still be stale placeholder data
   * until the real fetch resolves — skeleton them instead (the static
   * "all" chip is unaffected, it's never wrong). */
  loading?: boolean;
}

export default function ModeBar({ categories, activeChips, onToggleChip, onDeleteChip, loading = false }: ModeBarProps) {
  return (
    <div className={styles.modeBar}>
      <div className={styles.chips} role="tablist" aria-label="Content category filter">
        {categories.map(({ id, label, isCustom }) => (
          loading && id !== 'all' ? (
            <span key={id} className={styles.chipSkeleton} aria-hidden="true" />
          ) : (
            <button
              key={id}
              role="tab"
              aria-selected={activeChips.includes(id)}
              className={`${styles.chip} ${activeChips.includes(id) ? styles.chipActive : ''} ${isCustom ? styles.chipCustom : ''}`}
              onClick={() => onToggleChip(id)}
            >
              {label}
              {isCustom && onDeleteChip && (
                <span
                  className={styles.chipDelete}
                  role="button"
                  aria-label={`Delete ${label}`}
                  onClick={(e) => { e.stopPropagation(); onDeleteChip(id); }}
                >
                  ×
                </span>
              )}
            </button>
          )
        ))}
      </div>
    </div>
  );
}
